import type { ReactNode } from "react";

export type CatalogKey = "areas" | "puestos" | "origenes_candidato";
//| "beneficios"
//| "categoriasProveedores";

export interface ColumnDef<T> {
  key: keyof T | string;
  header: string;
  width?: number;
  render?: (v: any, row: T) => ReactNode;
}

export interface CatalogDefinition<T> {
  key: CatalogKey;
  title: string;
  basePath: string;
  apiBase: string;
  columns: Array<ColumnDef<T>>;
  filters?: Array<{
    type: "text" | "select";
    name: string;
    label: string;
    options?: Array<{ label: string; value: string }>;
  }>;
  permissions: {
    read: string;
    create: string;
    update: string;
    delete: string;
  };
  singleKey?: string;
}

export const CATALOGS: Record<CatalogKey, CatalogDefinition<any>> = {
  areas: {
    key: "areas",
    singleKey: "area",
    title: "Departamento/Área",
    basePath: "/catalogs/areas",
    apiBase: "/catalogos/areas",
    columns: [
      { key: "nombre", header: "Nombre" },
      { key: "descripcion", header: "Descripción" },
      {
        key: "encargado",
        header: "Encargado",
        render: (_v: any, row: any) => {
          if (row.encargado) {
            return `${row.encargado.firstName} ${row.encargado.lastName}`;
          }
          return "Sin asignar";
        },
      },
      { key: "createdAt", header: "Creado" },
    ],
    permissions: {
      read: "generales.catalogos.areas.read",
      create: "generales.catalogos.areas.create",
      update: "generales.catalogos.areas.update",
      delete: "generales.catalogos.areas.delete",
    },
  },
  /**
   * Origen del candidato (RH-06).
   *
   * La clave lleva guion bajo y no camelCase a proposito: `CatalogsPageSimple`
   * arma el permiso con ella (`generales.catalogos.${key}.read`), asi que tiene
   * que coincidir letra por letra con la fila de permissions.csv.
   */
  origenes_candidato: {
    key: "origenes_candidato",
    singleKey: "origen",
    title: "Origen de candidatos",
    basePath: "/catalogs/origenes-candidato",
    apiBase: "/catalogos/candidate-sources",
    columns: [
      { key: "name", header: "Nombre" },
      {
        key: "visibility",
        header: "Visibilidad",
        render: (v: string) =>
          v === "public" ? "Público e interno" : "Solo interno",
      },
      {
        key: "isReferral",
        header: "Pide recomendador",
        render: (v: boolean) => (v ? "Sí" : "No"),
      },
      { key: "sortOrder", header: "Orden" },
      {
        key: "isActive",
        header: "Estado",
        render: (v: boolean) => (v ? "Activo" : "Inactivo"),
      },
    ],
    permissions: {
      read: "generales.catalogos.origenes_candidato.read",
      create: "generales.catalogos.origenes_candidato.create",
      update: "generales.catalogos.origenes_candidato.update",
      delete: "generales.catalogos.origenes_candidato.delete",
    },
  },
  puestos: {
    key: "puestos",
    singleKey: "puesto",
    title: "Puestos",
    basePath: "/catalogs/puestos",
    apiBase: "/catalogos/puestos",
    columns: [
      { key: "nombre", header: "Nombre" },
      {
        key: "area",
        header: "Departamento/Área",
        render: (_v: any, row: any) => {
          if (row.area) {
            return row.area.nombre;
          }
          return "Sin Departamento/Área";
        },
      },
      { key: "descripcion", header: "Descripción" },
      {
        key: "activo",
        header: "Estado",
        render: (v: boolean) => (v ? "Activo" : "Inactivo"),
      },
    ],
    permissions: {
      read: "generales.catalogos.puestos.read",
      create: "generales.catalogos.puestos.create",
      update: "generales.catalogos.puestos.update",
      delete: "generales.catalogos.puestos.delete",
    },
  },
  /* beneficios: {
    key: "beneficios",
    singleKey: "beneficio",
    title: "Beneficios",
    basePath: "/catalogs/beneficios",
    apiBase: "/catalogos/beneficios",
    columns: [
      { key: "nombre", header: "Nombre" },
      { key: "tipo", header: "Tipo" },
      { key: "valor", header: "Valor" },
    ],
    permissions: {
      read: "catalogos.beneficios.read",
      create: "catalogos.beneficios.create",
      update: "catalogos.beneficios.update",
      delete: "catalogos.beneficios.delete",
    },
  }, */
  /* categoriasProveedores: {
    key: "categoriasProveedores",
    singleKey: "proveedor",
    title: "Proveedores",
    basePath: "/catalogs/categorias-proveedores",
    apiBase: "/catalogos/categorias-proveedores",
    columns: [
      { key: "codigo", header: "Código" },
      { key: "nombre", header: "Nombre" },
      { key: "descripcion", header: "Descripción" },
    ],
    permissions: {
      read: "proveedores.administracion.proveedores.consultar",
      create: "proveedores.administracion.proveedores.crear",
      update: "proveedores.administracion.proveedores.editar",
      delete: "proveedores.administracion.proveedores.desactivar",
    },
  }, */
};
